import Axios from "../../../../api/axios/Axios";

export const GLOBAL_SEARCH_TYPES = [
  "videos",
  "pops",
  "albums",
  "streams",
  "talents",
];

export const searchGlobalContent = (
  type,
  search,
  limit = 12,
  offset = 0,
  signal,
) => {
  if (!GLOBAL_SEARCH_TYPES.includes(type)) {
    throw new Error("Invalid search category.");
  }

  return Axios.get(`/api/search/global/${encodeURIComponent(type)}`, {
    params: {
      q: String(search || "").trim(),
      limit,
      offset,
    },
    signal,
  });
};
